import { CONTACT } from "@/lib/data";

export default function WhatsAppFloat() {
  return (
    <a
      href={CONTACT.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      className="wa-float fixed bottom-6 right-6 z-50 flex items-center justify-center w-11 h-11 bg-green-500 hover:bg-green-600 rounded-full shadow-lg transition-colors duration-300"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-float"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" className="w-6 h-6 fill-white">
        <path d="M16 .04C7.164.04.04 7.164.04 16c0 2.82.737 5.463 2.024 7.755L.04 31.96l8.418-2.007A15.93 15.93 0 0 0 16 31.96C24.836 31.96 31.96 24.836 31.96 16S24.836.04 16 .04zm0 29.12a13.13 13.13 0 0 1-6.694-1.833l-.48-.285-4.995 1.191 1.237-4.863-.314-.499A13.1 13.1 0 0 1 2.84 16C2.84 8.71 8.71 2.84 16 2.84S29.16 8.71 29.16 16 23.29 29.16 16 29.16zm7.19-9.822c-.394-.197-2.33-1.149-2.692-1.28-.362-.13-.625-.197-.888.197-.263.394-1.02 1.28-1.25 1.543-.23.263-.46.296-.854.099-.394-.197-1.664-.614-3.169-1.956-1.171-1.045-1.962-2.336-2.192-2.73-.23-.394-.025-.607.173-.803.177-.176.394-.46.591-.69.197-.23.263-.394.394-.657.131-.263.066-.493-.033-.69-.099-.197-.888-2.14-1.217-2.928-.32-.769-.645-.665-.888-.677l-.757-.013c-.263 0-.69.099-1.052.493-.362.394-1.382 1.35-1.382 3.293s1.415 3.818 1.612 4.081c.197.263 2.783 4.25 6.744 5.96.943.407 1.678.65 2.25.832.945.3 1.805.258 2.486.157.758-.113 2.33-.952 2.659-1.872.329-.92.329-1.708.23-1.872-.098-.164-.362-.263-.756-.46z" />
      </svg>
    </a>
  );
}
